import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router-dom";
import { resetPassword } from "../services/operations/authAPI";
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";

function UpdatePassword(props) {
  const { loading } = useSelector((state) => state.auth);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formData, setFormData] = useState({
    password: "",
    confimPassword: "",
  });
  const dispatch = useDispatch();
  const location = useLocation();
  const navigator = useNavigate();

  const handleOnChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };

  const { password, confimPassword } = formData;

  function handleOnSubmit(e) {
    e.preventDefault();
    const token = location.pathname.split("/").at(-1);
    dispatch(resetPassword(password, confimPassword, token,navigator));
  }

  return (
    <div className="flex w-full justify-center items-center">
      <div className="w-[50%] mt-[10rem] flex flex-col justify-center items-center">
        {loading ? (
          <div className='flex w-full h-screen justify-center items-center'>
            <div class="spinner"></div>
          </div>
        ) : (
          <div className="">
            <h1 className="text-3xl text-richblack-25 font-semibold">Choose new password</h1>
            <p className="text-richblack-100 text-md mt-1">Almost done. Enter your new password and you're all set.</p>
            <form onSubmit={handleOnSubmit}>
              <label className="gap-y-2 flex flex-col mt-4">
                <p className="text-richblack-100">
                  New Password <sup className="text-pink-200">*</sup>
                </p>
                <div>
                  <input
                  className="px-4 py-2 w-[100%] bg-richblack-800 rounded-md text-richblack-100"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    name="password"
                    placeholder="Enter password"
                    onChange={handleOnChange}
                    required
                  />
                  <span
                    onClick={() => {
                      setShowPassword((prev) => !prev);
                    }}>
                    {showPassword ? (
                      <AiOutlineEyeInvisible />
                    ) : (
                      <AiOutlineEye />
                    )}
                  </span>
                </div>
              </label>
              <label className="gap-y-2 flex flex-col mt-2">
                <p className="text-richblack-100">Confirm New Password <sup className="text-pink-200">*</sup></p>
                <div >
                  <input
                  className="px-4 py-2 w-[100%] bg-richblack-800 rounded-md text-richblack-100"
                    type={showConfirmPassword ? "text" : "password"}
                    value={confimPassword}
                    name="confimPassword"
                    placeholder="Confirm password"
                    onChange={handleOnChange}
                    required
                  />
                  <span
                    onClick={() => {
                      setShowConfirmPassword((prev) => !prev);
                    }}>
                    {showConfirmPassword ? (
                      <AiOutlineEyeInvisible />
                    ) : (
                      <AiOutlineEye />
                    )}
                  </span>
                </div>
              </label>
              <button className="text-center w-full text-[13px] px-6 py-3 rounded-md font-bold 
            bg-yellow-50
            hover:scale-95 transition-all duration-200 mt-2" type="submit">Reset Password</button>
            </form>
            <div className="text-richblack-25 mt-4">
              <Link to="/login" className="flex items-center gap-x-2">
                <FaArrowLeft /> <p>Back to Login</p>
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default UpdatePassword;
